/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
(function(global, factory) { /* global define, require, module */

    /* AMD */ if (typeof define === 'function' && define.amd)
        define(["protobufjs/light"], factory);

    /* CommonJS */ else if (typeof require === 'function' && typeof module === 'object' && module && module.exports)
        module.exports = factory(require("protobufjs/light"));

})(this, function($protobuf) {
    "use strict";

    var $root = ($protobuf.roots["default"] || ($protobuf.roots["default"] = new $protobuf.Root()))
    .addJSON({
      controller: {
        options: {
          go_package: "go/controller"
        },
        nested: {
          Controller: {
            fields: {
              locomotives: {
                keyType: "string",
                type: "Locomotive",
                id: 1
              },
              railwayModules: {
                keyType: "string",
                type: "RailwayModule",
                id: 2
              },
              started: {
                type: "bool",
                id: 3
              },
              reboot: {
                type: "bool",
                id: 4
              },
              poweroff: {
                type: "bool",
                id: 5
              },
              id: {
                type: "string",
                id: 6
              }
            },
            nested: {
              Locomotive: {
                fields: {
                  name: {
                    type: "string",
                    id: 1
                  },
                  address: {
                    type: "uint32",
                    id: 2
                  },
                  speed: {
                    type: "uint32",
                    id: 3
                  },
                  direction: {
                    type: "Direction",
                    id: 4
                  },
                  enabled: {
                    type: "bool",
                    id: 5
                  },
                  fl: {
                    type: "bool",
                    id: 6
                  },
                  f1: {
                    type: "bool",
                    id: 7
                  },
                  f2: {
                    type: "bool",
                    id: 8
                  },
                  f3: {
                    type: "bool",
                    id: 9
                  },
                  f4: {
                    type: "bool",
                    id: 10
                  },
                  f5: {
                    type: "bool",
                    id: 11
                  },
                  f6: {
                    type: "bool",
                    id: 12
                  },
                  f7: {
                    type: "bool",
                    id: 13
                  },
                  f8: {
                    type: "bool",
                    id: 14
                  },
                  f9: {
                    type: "bool",
                    id: 15
                  },
                  f10: {
                    type: "bool",
                    id: 16
                  },
                  f11: {
                    type: "bool",
                    id: 17
                  },
                  f12: {
                    type: "bool",
                    id: 18
                  },
                  f13: {
                    type: "bool",
                    id: 19
                  },
                  f14: {
                    type: "bool",
                    id: 20
                  },
                  f15: {
                    type: "bool",
                    id: 21
                  },
                  f16: {
                    type: "bool",
                    id: 22
                  },
                  f17: {
                    type: "bool",
                    id: 23
                  },
                  f18: {
                    type: "bool",
                    id: 24
                  },
                  f19: {
                    type: "bool",
                    id: 25
                  },
                  f20: {
                    type: "bool",
                    id: 26
                  },
                  f21: {
                    type: "bool",
                    id: 27
                  },
                  f22: {
                    type: "bool",
                    id: 28
                  },
                  f23: {
                    type: "bool",
                    id: 29
                  },
                  f24: {
                    type: "bool",
                    id: 30
                  },
                  f25: {
                    type: "bool",
                    id: 31
                  },
                  f26: {
                    type: "bool",
                    id: 32
                  },
                  f27: {
                    type: "bool",
                    id: 33
                  },
                  f28: {
                    type: "bool",
                    id: 34
                  }
                },
                nested: {
                  Direction: {
                    values: {
                      Backward: 0,
                      Forward: 1
                    }
                  }
                }
              },
              RailwayModule: {
                fields: {
                  name: {
                    type: "string",
                    id: 1
                  },
                  address: {
                    type: "uint32",
                    id: 2
                  },
                  enabled: {
                    type: "bool",
                    id: 3
                  },
                  routes: {
                    keyType: "string",
                    type: "Route",
                    id: 4
                  },
                  activeRoute: {
                    type: "string",
                    id: 5
                  }
                },
                nested: {
                  Route: {
                    fields: {
                      name: {
                        type: "string",
                        id: 1
                      },
                      f0: {
                        type: "bool",
                        id: 2
                      },
                      f1: {
                        type: "bool",
                        id: 3
                      },
                      f2: {
                        type: "bool",
                        id: 4
                      },
                      f3: {
                        type: "bool",
                        id: 5
                      },
                      f4: {
                        type: "bool",
                        id: 6
                      },
                      f5: {
                        type: "bool",
                        id: 7
                      },
                      f6: {
                        type: "bool",
                        id: 8
                      },
                      f7: {
                        type: "bool",
                        id: 9
                      },
                      f8: {
                        type: "bool",
                        id: 10
                      },
                      f9: {
                        type: "bool",
                        id: 11
                      },
                      f10: {
                        type: "bool",
                        id: 12
                      },
                      f11: {
                        type: "bool",
                        id: 13
                      },
                      f12: {
                        type: "bool",
                        id: 14
                      },
                      f13: {
                        type: "bool",
                        id: 15
                      },
                      f14: {
                        type: "bool",
                        id: 16
                      },
                      f15: {
                        type: "bool",
                        id: 17
                      },
                      f16: {
                        type: "bool",
                        id: 18
                      },
                      f17: {
                        type: "bool",
                        id: 19
                      },
                      f18: {
                        type: "bool",
                        id: 20
                      },
                      f19: {
                        type: "bool",
                        id: 21
                      },
                      f20: {
                        type: "bool",
                        id: 22
                      },
                      f21: {
                        type: "bool",
                        id: 23
                      },
                      f22: {
                        type: "bool",
                        id: 24
                      },
                      f23: {
                        type: "bool",
                        id: 25
                      },
                      f24: {
                        type: "bool",
                        id: 26
                      },
                      f25: {
                        type: "bool",
                        id: 27
                      },
                      f26: {
                        type: "bool",
                        id: 28
                      },
                      f27: {
                        type: "bool",
                        id: 29
                      },
                      f28: {
                        type: "bool",
                        id: 30
                      },
                      f29: {
                        type: "bool",
                        id: 31
                      },
                      f30: {
                        type: "bool",
                        id: 32
                      },
                      f31: {
                        type: "bool",
                        id: 33
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

    return $root;
});
